function initState() {
  return {
    alerts: [],
  };
}

const state = initState();

const mutations = {
  ADD_ALERT(state, alert) {
    alert.id = Math.max(...state.alerts.map((item) => item.id), 1);
    state.alerts.push({ ...alert });
    setTimeout(() => {
      state.alerts = state.alerts.filter((item) => alert.id !== item.id);
    }, 5000);
  },
  REMOVE_ALERT(state, id) {
    state.alerts = state.alerts.filter((alert) => alert.id !== id);
  },
};

const actions = {
  ADD_ALERT({ commit }, payload) {
    commit("ADD_ALERT", { text: payload });
  },
  REMOVE_ALERT({ commit }, payload) {
    commit("REMOVE_ALERT", payload);
  },
};

const getters = {
  isVisible(state) {
    return state.alerts.length > 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
